export const BRAND_NAME = 'authrz.me';
export const BRAND_DOMAIN = 'authrz.me';
export const BRAND_TAGLINE = 'Identity infrastructure for OAuth, OIDC, and product access.';
